import React from 'react';
import Dialog from 'src/components/common/Dialog.redesign';
import BrineLeaseChangeLog from './BrineLeaseChangeLog';
import EntityModificationContract from 'src/models/entityModificationLogs/EntityModificationContract';

interface IEntityChangeLogDialog {
    entityType: string;
    entityId: number;
    changeLogs: EntityModificationContract;
}

const EntityChangeLogDialog = (props: IEntityChangeLogDialog) => {
    // TODO: Either update this with the other Change Log types or deprecate it for something more universal.
    return (
        <Dialog title={`View Change Log - ${props.entityType}`}>
            <div style={{ maxHeight: '80vh', overflow: 'auto' }}>
                <BrineLeaseChangeLog
                    changeLogs={props.changeLogs}
                />
            </div>
        </Dialog>
    );
};

export default EntityChangeLogDialog;


// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/EntityModificationComponents/EntityChangeLogDialog.tsx